import React from "react";

interface FiltroPropiedadesProps {
    searchTerm: string;
    onSearchChange: (value: string) => void;
    filters: { id: string; label: string; queryStatus: string }[];
    activeFilter: string;
    onFilterChange: (id: string) => void;
    //sortOrder: string;
    //onSortChange: (value: string) => void;
    activeView: string;
    onViewChange: (view: string) => void;
}

const FiltroPropiedades: React.FC<FiltroPropiedadesProps> = ({
    searchTerm,
    onSearchChange,
    filters,
    activeFilter,
    onFilterChange,
    //sortOrder,
    //onSortChange,
    activeView,
    onViewChange
}) => {
    return (
        <div className="py-3 px-4 md:px-7 border-b border-gray-200 bg-white flex flex-col md:flex-row gap-3 md:items-center shrink-0">
            {/* Buscador */}
            <div className="flex items-center gap-2 bg-white border border-gray-300 rounded-lg px-3 py-[7px] w-full md:w-auto md:min-w-[340px] focus-within:border-[#4f6df5] focus-within:ring-1 focus-within:ring-[#4f6df5]/20 transition-all shrink-0">
                <svg width="16" height="16" fill="none" stroke="#9ca3af" strokeWidth="2" viewBox="0 0 24 24">
                    <circle cx="11" cy="11" r="8" />
                    <line x1="21" y1="21" x2="16.65" y2="16.65" />
                </svg>
                <input
                    type="text"
                    className="bg-transparent border-none outline-none text-[13px] text-gray-900 w-full placeholder:text-gray-400 text-ellipsis overflow-hidden whitespace-nowrap"
                    placeholder="Buscar por nombre, ciudad, anfitrión..."
                    value={searchTerm}
                    onChange={(e) => onSearchChange(e.target.value)}
                />
            </div>

            {/* Chips de filtro */}
            <div className="flex gap-2 overflow-x-auto w-full md:w-auto pb-1 md:pb-0 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
                {filters.map((filter) => (
                    <button
                        key={filter.id}
                        className={`text-[11px] font-semibold px-3 py-1.5 rounded-full border transition-all duration-200 whitespace-nowrap shrink-0 ${activeFilter === filter.id
                                ? "bg-[#4f6df5] border-[#4f6df5] text-white shadow-sm"
                                : "bg-white border-gray-200 text-gray-600 hover:text-gray-900 hover:border-gray-300 hover:bg-gray-50"
                            }`}
                        onClick={() => onFilterChange(filter.id)}
                    >
                        {filter.label}
                    </button>
                ))}
            </div>

            <div className="flex items-center gap-2 w-full md:w-auto md:ml-auto">

                {/* Select de ordenamiento */}
                {/* <select
                    className="w-full md:w-auto bg-[#1e2230] border border-[#2a2e3e] rounded-lg py-2 md:py-1.5 px-2.5 text-xs text-[#8b90a5] outline-none cursor-pointer transition-colors hover:border-[#5a5f75] focus:border-[#4f6df5] shrink-0"
                    value={sortOrder}
                    onChange={(e) => onSortChange(e.target.value)}
                >
                    <option value="recent">Más recientes</option>
                    <option value="highestPrice">Mayor precio</option>
                    <option value="mostBookings">Más reservas</option>
                    <option value="highestRating">Mejor rating</option>
                </select> */}

                {/* Toggle de vista */}
                <div className="hidden md:flex bg-gray-100 border border-gray-200 rounded-lg p-[3px] gap-[2px]">
                    <button
                        onClick={() => onViewChange('grid')}
                        className={`w-[30px] h-[28px] rounded-md border-none flex items-center justify-center transition-colors ${activeView === 'grid' ? 'bg-white text-[#4f6df5] shadow-sm' : 'bg-transparent text-gray-500 hover:text-gray-900'}`}
                    >
                        <svg width="14" height="14" fill="currentColor" viewBox="0 0 24 24"><rect x="3" y="3" width="7" height="7" rx="1" /><rect x="14" y="3" width="7" height="7" rx="1" /><rect x="3" y="14" width="7" height="7" rx="1" /><rect x="14" y="14" width="7" height="7" rx="1" /></svg>
                    </button>
                    <button
                        onClick={() => onViewChange('list')}
                        className={`w-[30px] h-[28px] rounded-md border-none flex items-center justify-center transition-colors ${activeView === 'list' ? 'bg-white text-[#4f6df5] shadow-sm' : 'bg-transparent text-gray-500 hover:text-gray-900'}`}
                    >
                        <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><line x1="8" y1="6" x2="21" y2="6" /><line x1="8" y1="12" x2="21" y2="12" /><line x1="8" y1="18" x2="21" y2="18" /></svg>
                    </button>
                </div>
                
            </div>
        </div>
    );
};

export default FiltroPropiedades;